import { Route, Routes } from "react-router-dom";
import ServiceFailure from "./pages/ServiceFailure";
import ServiceFailures from "./pages/serviceFailures";

export function CustomerServiceFailuresRoutes() {
	return (
		<Routes>
			<Route index element={<ServiceFailures />} />
			<Route path=":orderNumber" element={<ServiceFailure />} />
		</Routes>
	);
}
